import { ServiceSessionUserEvent } from '@modules/ServiceModule/workspace/types/ServiceEvents';
import { InboxContext } from '../types';

function handleSessionWrapupCompleted(
  context: InboxContext,
  event: ServiceSessionUserEvent,
) {
  if (context.userId !== event.userId) {
    return;
  }
  // nothing to do here
}

export default handleSessionWrapupCompleted;
